/*
 * @Author: wsx
 * @Date: 2022-01-19 09:28:58
 * @LastEditTime: 2022-04-21 14:53:16
 * @LastEditors: Please set LastEditors
 * @Description:
 */
import request from "@/utils/request.js";

// 获取人口信息列表
export const queryUserList = data => {
  return request({
    url: "/api/hz-smart-community/prison/info/list",
    params: data || {}
  });
};

// 保存人口信息
export const saveQuery = data => {
  return request({
    url: "/api/hz-smart-community/prison/info/save",
    data: data || {},
    method: "POST"
  });
};

// 修改人口信息
export const updateQuery = data => {
  return request({
    url: "/api/hz-smart-community/prison/info/update",
    data: data || {},
    method: "POST"
  });
};

// 删除人口信息
export const deleteQuery = data => {
  return request({
    url: "/api/hz-smart-community/prison/info/delete",
    data: data || {},
    method: "POST"
  });
};
// 地域管理
export const areaselectList = data => {
  return request({
    url: "/api/hz-smart-community/sys/district/select",
    params: data || {}
  });
};

// 信息
export const infoQuery = data => {
  return request({
    url: "/api/hz-smart-community/prison/info/info/" + data,
    params: data || {}
  });
};

// 通过faceId这个id获取对应的详情

export const infofaceId = data => {
  return request({
    url: "/api/hz-smart-community/prison/info/infoByFaceId",
    params: data || {}
  });
};

// 通过身份证查询人员详情

export const infoByCardNum = data => {
  return request({
    url: "/api/hz-smart-community/prison/info/infoByCardNum",
    params: data || {}
  });
};

// 保存居住人员
export const savePrison = data => {
  return request({
    url: "/api/hz-smart-community/house/info/savePrison",
    data: data || {},
    method: "POST"
  });
};
// 删除居住人员
export const deletePrison = data => {
  return request({
    url: "/api/hz-smart-community/house/info/deletePrison",
    data: data || {},
    method: "POST"
  });
};
// 保存居住人员
export const weglist = data => {
  return request({
    url: "/api/hz-smart-community/house/weg/list",
    params: data || {}
  });
};
// 保存居住人员
export const infolistAll = data => {
  return request({
    url: "/api/hz-smart-community/region/info/listAll",
    params: data || {}
  });
};
// 获取人口信息
export const getUserList = data => {
  return request({
    url: "/apiData/hz-data-community/daas/rkxx/info",
    params: data || {}
  });
};
// 单位绑定人员
export const unitSelectPrison = data => {
  return request({
    url: "/api/hz-smart-community/unit/info/selectPrison",
    data: data || {},
    method: "POST"
  });
};